import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { environment } from '@env/environment';
import { Product } from '@shared/models';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-products-single',
    templateUrl: './products-single.component.html',
    styleUrls: ['./products-single.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe],
})
export class ProductsSingleComponent {
    @Input({ required: true }) product!: Product;
    @Input({ required: true }) categorySlug!: string | null;

    get showWidthWithStone(): boolean {
        if (this.product.parameters.width_z_kam) {
            return this.product.parameters.width !== this.product.parameters.width_z_kam;
        }
        return false;
    }

    get showHeightWithStone(): boolean {
        if (this.product.parameters.height_z_kam) {
            return this.product.parameters.height !== this.product.parameters.height_z_kam;
        }
        return false;
    }

    get img(): string {
        if (this.product?.image?.url) {
            return this.product.image.url;
        }
        return environment.serverUrl + `api/public/product/catalogue/image/${this.product.patternName}`;
    }

    get height(): number {
        return parseFloat(this.product.parameters.height);
    }

    get weight(): string {
        if (this.product.parameters.weight) {
            return this.product.parameters.weight;
        }
        return '';
    }

    get backLink() {
        return this.categorySlug ? ['..'] : ['../..'];
    }
}
